<form [formGroup]="form">
  <mat-form-field class="full-width">
    <mat-label>Médico derivante</mat-label>
    <input
      type="text"
      #referringPhysicianCtrl
      formControlName="ReferringPhysicianCtrl"
      matInput
      placeholder="Busque al médico por apellido, nombre o matrícula"
      (input)="onReferringPhysicianFilterChange()"
      [matAutocomplete]="autReferringPhysician"
    />
    <mat-autocomplete
      #autReferringPhysician="matAutocomplete"
      (optionSelected)="referringPhysicianFilterSelected($event.option.value)"
      [displayWith]="displayFn"
    >
      <mat-option
        *ngFor="let referringPhysicianFilter of referringPhysiciansFilter"
        [value]="referringPhysicianFilter"
      >
        <div>
          <b>{{ referringPhysicianFilter.LastName }}</b
          >, {{ referringPhysicianFilter.FirstName }} [{{
            referringPhysicianFilter.Enrollment
          }}]
        </div>
      </mat-option>
    </mat-autocomplete>
    <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>
  </mat-form-field>
  <button
    matSuffix
    type="button"
    *ngIf="canEdit === true && !loading && !isSelected && !readOnly"
    (click)="create()"
    mat-mini-fab
  >
    <mat-icon>add</mat-icon>
  </button>
  <button
    matSuffix
    type="button"
    *ngIf="canEdit === true && !loading && isSelected && !readOnly"
    (click)="edit()"
    mat-mini-fab
  >
    <mat-icon>edit</mat-icon>
  </button>
</form>
